import React from "react";

import ShipeeziNewGrid, { Column, RowActionsExtra } from "Components/AppGrid/shipeezi-new-grid";

import NotEnoughData from "../../../DashMetrics/NotEnoughData";
import useStyles from "./styles";

interface Props {
  columns: Column[];
  data: any[];
  rowActions?: RowActionsExtra[];
}

const OverviewTable = ({ columns, data, rowActions }: Props) => {
  const classes = useStyles();

  if (!data.length) return <NotEnoughData />;

  return (
    <div className={classes.container}>
      <ShipeeziNewGrid
        data={data}
        columns={columns}
        positionActionsColumn="right"
        rowActionsExtra={rowActions}
        showSelection={false}
        showColumnChooser={false}
      />
    </div>
  );
};

export default OverviewTable;
